import { render, staticRenderFns } from "./VipDetail.vue?vue&type=template&id=59bf4bd0&scoped=true&"
import script from "./VipDetail.vue?vue&type=script&lang=js&"
export * from "./VipDetail.vue?vue&type=script&lang=js&"
import style0 from "./VipDetail.vue?vue&type=style&index=0&id=59bf4bd0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf4bd0",
  null
  
)

export default component.exports